// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAmUYlSxsdiIgIlRZFVopimJ2EkXJ-pxwk",
    authDomain: "gallery-pradarshak.firebaseapp.com",
    projectId: "gallery-pradarshak",
    storageBucket: "gallery-pradarshak.appspot.com",
    messagingSenderId: "1046443257817",
    appId: "1:1046443257817:web:498c30ace810066e4f33c8",
    measurementId: "G-P73DD9HB9L"
  };

  export default firebaseConfig;